<template>
  <div id="app">
    <pageIntro></pageIntro>
    <loading></loading>

    <transition
      v-on:before-enter="beforeEnter"
      v-on:enter="enter"
      v-on:leave="leave"
      v-bind:css="false"
      mode="out-in"
    >
      <router-view> </router-view>
    </transition>
  </div>
</template>

<script>
import pageIntro from "./components/blocks/pageIntro";
import loading from "./components/loading";

export default {
  name: "app",
  components: {
    pageIntro: pageIntro,
    loading: loading
  },
  methods: {
    beforeEnter: function(el) {
      el.style.opacity = 0;
      window.scrollTo({
        top: 0
      });
    },
    enter: function(el, done) {
      this.$globalFunctions.disableBodyScroll(false);
      TweenMax.to(el, 0.5, {
        opacity: 1,
        ease: Power4.easeOut,
        delay: 0.25,
        onComplete: function() {
          console.log("enter");
          done();
        }
      });
      // I only see the text enter sometimes for a page. Its not consistently firing
    },

    leave: function(el, done) {
      // I only see the text leave sometimes for a page. Its not consistently firing
      TweenMax.to(el, 0.5, {
        opacity: 0,
        ease: Power4.easeOut,
        delay: 0.25,
        onComplete: function() {
          console.log("leave");
          done();
        }
      });
    }
  },
  mounted() {
    this.$store.commit("setAllShows"); // Mudar o commit para o load da app provavelmente no app.vue
  }
};
</script>
<!-- styling for the component -->
<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue